"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Box } from "@mui/material"
import { useNotification } from "../../contexts/NotificationContext"
import { useAuth } from "../../contexts/AuthContext"
import PageHeader from "../../components/common/PageHeader"
import PlanForm from "../../components/plans/PlanForm"
import { createPlan } from "../../services/subscription.service"
import useOrganizationParams from "../../hooks/useOrganizationParams"

const CreatePlan = () => {
  const navigate = useNavigate()
  const { showNotification } = useNotification()
  const { user, selectedOrganization } = useAuth()
  const organizationParams = useOrganizationParams()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (formData) => {
    setLoading(true)
    try {
      const response = await createPlan(formData, organizationParams)
      showNotification("Plan created successfully", "success")
      navigate(`/plans/${response.data._id}`)
    } catch (error) {
      showNotification(error.response?.data?.message || "Failed to create plan", "error")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box>
      <PageHeader
        title="Create Plan"
        subtitle="Create a new subscription plan"
        breadcrumbs={[
          { text: "Dashboard", link: "/dashboard" },
          { text: "Plans", link: "/plans" },
          { text: "Create Plan" },
        ]}
      />

      <PlanForm onSubmit={handleSubmit} loading={loading} />
    </Box>
  )
}

export default CreatePlan

